import { GO_DIRECTIONS, timing, variantForLevel, } from './params';
const FEEDBACK_MS = timing.feedbackMs;
export function makeStimulus(trialIdx, ssdMs, level) {
    const variant = variantForLevel(level);
    const isStopTrial = Math.random() < variant.stopRate;
    const goDirection = GO_DIRECTIONS[Math.floor(Math.random() * GO_DIRECTIONS.length)];
    return {
        trialIdx,
        value: Math.max(50, ssdMs),
        goDirection,
        isStopTrial,
        responseWindowMs: variant.responseWindowMs,
    };
}
export function createStopSignalAdapter(level = 1) {
    let state = {
        subPhase: 'idle',
        stim: null,
        feedback: null,
        level,
        variant: variantForLevel(level),
        stopActive: false,
    };
    const listeners = new Set();
    let resolver = null;
    let rejecter = null;
    let trialStart = 0;
    const timers = [];
    function clearTimers() {
        while (timers.length > 0) {
            const t = timers.pop();
            if (t !== undefined)
                clearTimeout(t);
        }
    }
    function update(patch) {
        state = { ...state, ...patch };
        for (const l of listeners) {
            try {
                l(state);
            }
            catch {
                /* ignored */
            }
        }
    }
    function settle(pickedDirection, stim) {
        if (!resolver)
            return;
        const responded = pickedDirection !== null;
        const rt = responded ? Date.now() - trialStart : stim.responseWindowMs;
        let correct;
        if (stim.isStopTrial) {
            correct = !responded;
        }
        else {
            correct = responded && pickedDirection === stim.goDirection;
        }
        const r = resolver;
        resolver = null;
        rejecter = null;
        r({ pickedDirection, responded, correct, reactionTimeMs: rt });
    }
    return {
        mount() {
            // Idempotent.
        },
        unmount() {
            clearTimers();
            listeners.clear();
            if (rejecter) {
                rejecter(new Error('unmount'));
                rejecter = null;
                resolver = null;
            }
        },
        presentStimulus(stim) {
            clearTimers();
            return new Promise((resolve, reject) => {
                resolver = resolve;
                rejecter = reject;
                update({
                    subPhase: 'fixation',
                    stim,
                    feedback: null,
                    stopActive: false,
                });
                timers.push(setTimeout(() => {
                    update({ subPhase: 'go_stimulus', stopActive: false });
                    trialStart = Date.now();
                    // Transition vers awaiting_input immédiatement après le tick
                    // d'affichage de la flèche : la fenêtre de réponse globale court
                    // depuis go_stimulus.
                    update({ subPhase: 'awaiting_input' });
                    // Si Stop trial : pose le stop signal après SSD ms.
                    if (stim.isStopTrial) {
                        timers.push(setTimeout(() => {
                            update({ subPhase: 'stop_signal', stopActive: true });
                        }, stim.value));
                    }
                    // Timeout fenêtre réponse globale.
                    timers.push(setTimeout(() => {
                        settle(null, stim);
                    }, stim.responseWindowMs));
                }, timing.fixationMs));
            });
        },
        async showFeedback(correct) {
            update({
                subPhase: 'feedback',
                feedback: correct ? 'correct' : 'incorrect',
            });
            await new Promise((resolve) => {
                timers.push(setTimeout(() => {
                    update({ subPhase: 'iti', stopActive: false });
                    resolve();
                }, FEEDBACK_MS));
            });
        },
        pause() {
            // Sprint 0.5 : no-op.
        },
        resume() {
            // Sprint 0.5 : no-op.
        },
        abort() {
            clearTimers();
            if (rejecter) {
                rejecter(new Error('aborted'));
                rejecter = null;
                resolver = null;
            }
        },
        getState() {
            return state;
        },
        subscribe(listener) {
            listeners.add(listener);
            listener(state);
            return () => {
                listeners.delete(listener);
            };
        },
        handleDirection(direction) {
            if (state.subPhase !== 'awaiting_input' &&
                state.subPhase !== 'stop_signal' &&
                state.subPhase !== 'go_stimulus') {
                return;
            }
            const stim = state.stim;
            if (!stim)
                return;
            clearTimers();
            settle(direction, stim);
        },
        setLevel(newLevel) {
            const v = variantForLevel(newLevel);
            update({ level: newLevel, variant: v });
        },
    };
}
//# sourceMappingURL=adapter.js.map